import { Record } from 'immutable';

export default Record({
    id: null,
    name: '',
    parentId: null,
});



// WEBPACK FOOTER //
// ./src/records/category.js